var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81394 11.0581C7.17751 10.6512 7.45946 10.3257 7.74883 10.0083C10.598 6.88325 13.4472 3.75822 16.2964 0.633189C16.979 -0.123655 17.8323 -0.205036 18.4778 0.405322C19.0788 0.974989 19.1753 1.94342 18.693 2.6433C18.5965 2.78165 18.4778 2.91186 18.3665 3.03393C14.9534 6.7856 11.5329 10.5291 8.1124 14.2808C7.23686 15.2411 6.43553 15.2411 5.55258 14.2727C3.88313 12.4416 2.21368 10.6105 0.544238 8.77943C-0.0345037 8.14466 -0.15322 7.40409 0.195509 6.71235C0.640695 5.8253 1.6943 5.58116 2.42886 6.19965C2.55499 6.30545 2.67371 6.42752 2.78501 6.55773C4.03153 7.91679 5.28547 9.28399 6.53199 10.6593C6.62102 10.7651 6.69522 10.8953 6.81394 11.0581Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.02ea7d739245181e876cb72ea9861efd.svg";
export { ForwardRef as ReactComponent };